/**
 * openLiveAppStore — « Installer l'appli » depuis le navigateur d'un téléphone, du même geste à
 * l'entrée du live (le choix du navigateur) et dans le live (le bandeau) : le clic mesuré sous
 * `download_app.store_click`, avec le store et la source (`trackStoreClick` de
 * `common/utils/storeLinks`), puis la fiche de l'app (`liveStoreUrl` : la configuration serveur,
 * celle du build, le lien de repli) dans un nouvel onglet.
 *
 * Pur : aucun état, aucun hook — un écran peut l'appeler directement.
 */
import * as amplitude from "@amplitude/analytics-react-native"
import Constants from "expo-constants"

import { liveStoreFor, liveStoreUrl } from "../../adapters/student/LiveEntry/liveBrowserAdapter"
import { openExternalUrl } from "./openExternalUrl"

/** D'où part le clic, la source que les tableaux lisent. */
export type LiveAppStoreSource = "precall_browser_choice" | "live_web_mobile_banner"

/** Les fiches que sert la configuration serveur (`staticData`). */
export type LiveAppStoreUrls = { iosAppUrl?: string | null; androidAppUrl?: string | null }

type ExpoStoreConfig = { ios?: { appStoreUrl?: string }; android?: { playStoreUrl?: string } } | null

/** L'agent du navigateur ; vide hors du web. */
export function browserUserAgent(): string {
    return typeof navigator !== "undefined" ? (navigator.userAgent ?? "") : ""
}

export function openLiveAppStore(source: LiveAppStoreSource, urls: LiveAppStoreUrls): void {
    const store = liveStoreFor(browserUserAgent())
    amplitude.track("download_app.store_click", { store, source })
    const expo = Constants.expoConfig as ExpoStoreConfig
    openExternalUrl(
        liveStoreUrl(store, {
            ...urls,
            buildIos: expo?.ios?.appStoreUrl,
            buildAndroid: expo?.android?.playStoreUrl,
        })
    )
}
